/**
 * Created by Owner on 2016/8/6.
 * 包胆
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";

@Component({
  selector: 'lottery-math-bd',
  templateUrl: 'selectMath.html',
})
export class LotteryMathBDComponent extends LotteryMathZXFSComponent implements LotteryMath {

  changeTotal() {
    let mname = this.selectAreaOption["mname"];
    let tmpTotal: number = 1;
    let matchFn = {
      "ZU3BD": ()=>54,
      "ZU2BD": ()=>9
    };
    tmpTotal = matchFn[mname]();
    this.setTotal(tmpTotal);
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/bd.ts